import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/shared/hooks/useToast';
import { useRealtimeEvento } from '@/shared/lib/realtime/useRealtime';
import { dataIsoLocal, destinoNotificacao } from './destinoNotificacao';
import { estiloTipoNotificacao } from './estiloTipoNotificacao';
import { lerNotificacaoRealtime } from './notificacaoTypes';
import { notificacaoKeys, useMarcarNotificacaoLida } from './useNotificacaoQueries';

const EVENTO_NOTIFICACAO_NOVA = 'NOTIFICACAO_NOVA';

/**
 * Toast e badge quando chega aviso com a web aberta (R9). Independe do FCM:
 * funciona mesmo sem Firebase configurado no ambiente.
 */
export function useNotificacaoRealtime(enabled = true) {
  const queryClient = useQueryClient();
  const toast = useToast();
  const navigate = useNavigate();
  const marcarLida = useMarcarNotificacaoLida();

  const onEvento = useCallback(
    (evento: { payload: Record<string, unknown> }) => {
      const aviso = lerNotificacaoRealtime(evento.payload);
      if (!aviso) return;
      const estilo = estiloTipoNotificacao(aviso.tipo);
      const titulo = aviso.titulo?.trim() || estilo.rotulo;
      const destino = destinoNotificacao({
        idPublicacao: aviso.idPublicacao,
        idAluno: aviso.idAluno,
        idComentario: aviso.idComentario,
        dataPublicacao: aviso.dataPublicacao,
        criadoEm: `${dataIsoLocal()}T00:00:00`,
      });
      toast.info(aviso.mensagem ? `${titulo}: ${aviso.mensagem}` : titulo, {
        onClick: destino
          ? () => {
              if (aviso.idNotificacao != null && aviso.idNotificacao > 0) {
                marcarLida.mutate(aviso.idNotificacao);
              }
              navigate(destino);
            }
          : undefined,
      });
      void queryClient.invalidateQueries({ queryKey: notificacaoKeys.all });
    },
    [marcarLida, navigate, queryClient, toast],
  );

  useRealtimeEvento(EVENTO_NOTIFICACAO_NOVA, onEvento, enabled);
}
